<template>
  <v-main>
    <v-container fluid grid-list-xs pt-5>
      <v-layout row wrap justify-center align-center>
        <v-flex xs11 lg11>
          <h2>
            <v-icon color="#077893" @click="Fn_BackIndex" size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("Template.create_template") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-center pa-1>
        <v-flex xs11 lg11>
          <v-form ref="form" v-model="valid">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("Template.template_data") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-5">
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b
                      >ชื่อเทมเพลท (ฺTemplate Name)
                      <span style="color: red">*</span></b
                    >
                    <v-text-field
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                      outlined
                      dense
                      maxlength="200"
                      color="#077893"
                      v-model="Name"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>หัวข้อ</b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Title"
                      maxlength="200"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>การแจ้งเตือน <span style="color: red">*</span></b>
                    <!-- <p>{{typeof radioCheckNoti || 'null' }}</p> -->
                    <v-text-field
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                      outlined
                      dense
                      maxlength="200"
                      color="#077893"
                      v-model="Notification"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>รายละเอียด</b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Details"
                      maxlength="1000"
                      counter
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Account id</b>
                    <v-text-field
                      hide-details
                      outlined
                      disabled
                      dense
                      color="#077893"
                      v-model="AccountId"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="RuleBotName"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Business ID</b>
                    <v-text-field
                      hide-details
                      outlined
                      disabled
                      dense
                      color="#077893"
                      v-model="BusinessId"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[
                        (v) => !!(v && v.trim()) || 'กรุณากรอกข้อมูลให้ครบถ้วน',
                      ]"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 lg11>
                    <b>รูปภาพ <span style="color: red">*</span></b>
                    <v-card outlined>
                      <v-card-text>
                        <v-flex xs11 sm11 md11 lg11 pa-1>
                          <div>
                            <v-file-input
                              v-model="selectedFile"
                              accept=".png"
                              truncate-length="10"
                              label="อัปโหลดรูปภาพ"
                              prepend-icon="mdi-image-plus"
                              :rules="[(v) => !!v || 'กรุณาอัปโหลดรูปภาพ']"
                              @change="onFileChange"
                            ></v-file-input>

                            <!-- แสดงรูปภาพที่เลือก -->
                            <v-card
                              v-if="imagePreview"
                              class="mt-4 pa-3"
                              max-width="300"
                            >
                              <v-img
                                :src="imagePreview"
                                alt="Preview"
                                contain
                              ></v-img>
                            </v-card>
                          </div>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout row wrap justify-center align-center pb-5>
                  <v-flex xs10 md3 lg3>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      :loading="LoadingSave"
                      @click="Fn_CreateTemplate"
                      >{{ $t("policyForm.save") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: () => {
    return {
      // selectedFile: {
      //   lastModified: 1726131176843,
      //   lastModifiedDate: "Thu Sep 12 2024 15:52:56 GMT+0700 (Indochina Time)",
      //   name: "united-kingdom.png",
      //   size: 8723,
      //   type: "image/png",
      //   webkitRelativePath: "",
      // },
      selectedFile: null,
      // imagePreview: require("@/assets/img/user.png"),
      imagePreview: "",
      Notification: "",
      Name: "",
      Title: "",
      BusinessId: "",
      Bot_ID: "",
      Details: "",
      AccountId: "",
      valid: true,
      SenderDisplayName: "",
      LoadingSave: false,
      RuleEmailAddress: [
        (v) => !!v || "กรุณากรอกอีเมลแอดเดรสผู้ส่ง",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      RuleBotName: [(v) => !!(v && v.trim()) || "กรุณากรอกชื่อบอท"],
    };
  },
  computed: {},
  mounted() {
    this.Fn_GetOneData();
  },
  methods: {
    Fn_GetOneData() {
      this.AccountId = this.$cookies.get("OneAccountId");
      this.BusinessId = this.$cookies.get("BusinessId");
    },
    Fn_BackIndex() {
      this.$router.push("/template-bot");
    },
    async Fn_CreateTemplate() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const formData = new FormData();
        formData.append("Name", this.Name);
        formData.append("BusinessId", this.BusinessId);
        formData.append("AccountId", this.AccountId);
        formData.append("Details", this.Details);
        formData.append("Title", this.Title);
        formData.append("CustomNotification", this.Notification);
        formData.append("Image", this.selectedFile); // ไฟล์แนบ
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var auth = await authorization.encodeDataNew(Headers);
        var headers = {
          Authorization: "Bearer " + auth,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
          "ngrok-skip-browser-warning": "true",
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + `onechat/Template`,
            formData,
            {
              headers,
            }
          )
          .then((response) => {
            Toast.fire({
              icon: "success",
              title: this.$i18n.t("Template.add_success"),
            });
            this.$router.push("/template-bot");
            // this.tableload = false;
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    onFileChange(file) {
      this.selectedFile = file;
      if (file) {
        this.imagePreview = URL.createObjectURL(file); // สร้าง URL สำหรับ preview
      } else {
        this.imagePreview = null; // รีเซ็ตถ้าไม่มีไฟล์
      }
    },

  },
  watch: {
  },
};
</script>

<style></style>
